import { render, staticRenderFns } from "./ClinicNewBankOrder.vue?vue&type=template&id=ca10ad76"
import script from "./ClinicNewBankOrder.vue?vue&type=script&lang=js"
export * from "./ClinicNewBankOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports